import ContentFailedToDownload from './ContentFailedToDownload'
export default ContentFailedToDownload
